<mat-tab-group [selectedIndex]="stage"
               class="a7-ui-auth-form_tab-group">
  <!-- selectedIndex 0: Reset password form -->
  <mat-tab>
    <a7-auth-form-tab [formGroup]="form">
      <div class="center-inner v2-margin-2-b">
        <div class="color-green-grey-1 h1 nowrap">
          Reset Your Password
        </div>
      </div>
      <ng-container *ngIf="!useToken">
        <mat-form-field class="full-width a7-form-field v2-margin-40px-t"
                        [hideRequiredMarker]="true">
          <div matPrefix
               class="v2-h-5 v2-w-4 center-inner">
            <img src="/assets/v2-email.svg"
                 alt="email" />
          </div>

          <input matInput
                 name="email"
                 formControlName="email"
                 placeholder="Email">
          <mat-error *ngIf="
          form.controls.email.hasError('email') ||
          form.controls.email.hasError('required')">
            Please enter your email.</mat-error>
        </mat-form-field>
        <mat-form-field class="full-width a7-form-field"
                        [hideRequiredMarker]="true">
          <div matPrefix
               class="v2-h-5 v2-w-4 center-inner">
            <span class="form-icon text-primary icon-code-weight-3"
                  style="font-weight: 900; font-size:21px;">
            </span>
          </div>

          <input matInput
                 name="code"
                 formControlName="code"
                 placeholder="Code">
          <mat-error *ngIf="form.controls.code.hasError('required')">
            Please enter the code you received.</mat-error>
        </mat-form-field>
      </ng-container>

      <mat-form-field class="full-width a7-form-field"
                      [hideRequiredMarker]="true">
        <div matPrefix
             class="v2-h-5 v2-w-4 center-inner">
          <img src="/assets/v2-password.svg"
               alt="password" />
        </div>

        <input matInput
               type="password"
               autocomplete="new-password"
               name="password"
               formControlName="password"
               placeholder="Password">

        <mat-error *ngIf="form.controls.password.hasError('required')">
          Please enter a password.
        </mat-error>
        <mat-error *ngIf="form.controls.password.hasError('minlength')">
          Please enter at least 8 characters.
        </mat-error>
        <mat-error *ngIf="form.controls.password.hasError('pattern') && !form.controls.password.hasError('minlength')"
                   [ngSwitch]="form.controls.password.errors['pattern'].requiredPattern">
          <ng-container *ngSwitchCase="'/[A-Z]/'">
            Please enter at least 1 upper character.
          </ng-container>
          <ng-container *ngSwitchCase="'/[a-z]/'">
            Please enter at least 1 lower character.
          </ng-container>
          <ng-container *ngSwitchCase="'/[0-9]/'">
            Please enter at least 1 lower character.
          </ng-container>
        </mat-error>
        <mat-error *ngIf="form.controls.password.hasError('invalid')">
          Password is invalid.
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width a7-form-field"
                      [hideRequiredMarker]="true">
        <div matPrefix
             class="v2-h-5 v2-w-4 center-inner">
          <img src="/assets/v2-password.svg"
               alt="password" />
        </div>

        <input matInput
               type="password"
               autocomplete="new-password"
               name="confirmPassword"
               formControlName="confirmPassword"
               placeholder="Confirm Password">

        <mat-error *ngIf="form.controls.confirmPassword.hasError('match')">
          Password doesn't match.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="a7-form-field"
                      [hideRequiredMarker]="true">
        <div matPrefix
             class="v2-h-5 v2-w-4 center-inner svg-primary-green-1">
          <img src="/assets/v2-icons/Profile.svg"
               style="width:28px;" />
        </div>

        <input matInput
               formControlName="firstName"
               name="first"
               placeholder="First name" />

        <mat-error *ngIf="form.controls.firstName.hasError('required')">
          Please enter your first name.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="a7-form-field"
                      [hideRequiredMarker]="true">
        <div matPrefix
             class="v2-h-5 v2-w-4 center-inner svg-primary-green-1">
          <img src="/assets/v2-icons/Profile.svg"
               style="width:28px;" />
        </div>
        <input matInput
               formControlName="lastName"
               name="last"
               placeholder="Last name" />

        <mat-error *ngIf="form.controls.lastName.hasError('required')">
          Please enter your last name.
        </mat-error>
      </mat-form-field>

      <div class="full-width text-left h5 color-green-grey-3">
        Date of Birth
      </div>
      <div class="flex-row-start-center full-width v2-col-gap-1"
           a7SequentialInputGroup>

        <mat-form-field class="i2-fix"
                        [hideRequiredMarker]="true"
                        class="v2-w-6">
          <input matInput
                 inputmode="numeric"
                 placeholder="MM"
                 a7Restriction="\d\d"
                 a7SequentialInput
                 common-field-input
                 formControlName="dateOfBirthMonth">
        </mat-form-field>

        <span class="h4">/</span>

        <mat-form-field class="i3-fix"
                        [hideRequiredMarker]="true"
                        class="v2-w-6">
          <input matInput
                 placeholder="DD"
                 inputmode="numeric"
                 a7SequentialInput
                 a7Restriction="\d\d"
                 common-field-input
                 formControlName="dateOfBirthDay">
        </mat-form-field>

        <span class="h4">/</span>

        <mat-form-field class="i1-fix"
                        [hideRequiredMarker]="true"
                        class="v2-w-7">
          <input matInput
                 inputmode="numeric"
                 placeholder="YYYY"
                 a7Restriction="\d\d\d\d"
                 a7SequentialInput
                 common-field-input
                 formControlName="dateOfBirthYear">
        </mat-form-field>
      </div>

      <a7-button a7-auth-form-actions
                 theme="filled-heavy"
                 widthClass="full-width"
                 [disabled]="!form.valid || sending"
                 (click)="resetPassword()">
        Reset Password
      </a7-button>

    </a7-auth-form-tab>
  </mat-tab>

  <!-- selectedIndex 1: Token expired -->
  <mat-tab>
    <a7-auth-form-tab>
      <div class="center-inner">
        <div class="color-green-grey-1 h1 nowrap">
          Token Expired
        </div>
      </div>
      <div class="body-2 color-green-grey-3 v2-margin-40px-t">
        The token has been expired.
      </div>
      <div class="center-inner v2-margin-40px-t">
        <img src="/assets/v2-fail.svg"
             alt="back" />
      </div>
      <a7-button a7-auth-form-actions
                 class="v2-margin-40px-t"
                 theme="outlined-light"
                 widthClass="full-width"
                 [routerLink]="['/a/forgot-password']">
        Forgot password
      </a7-button>
    </a7-auth-form-tab>
  </mat-tab>

  <!-- selectedIndex 2: Code mismatch -->
  <mat-tab>
    <a7-auth-form-tab>
      <div class="center-inner">
        <div class="color-green-grey-1 h1 nowrap">
          Code Mismatch
        </div>
      </div>
      <div class="body-2 color-green-grey-3 v2-margin-40px-t">
        The password reset code is invalid, please click the following button to obtain a new code.
      </div>
      <div class="center-inner v2-margin-40px-t">
        <img src="/assets/v2-fail.svg"
             alt="back" />
      </div>
      <a7-button a7-auth-form-actions
                 class="v2-margin-40px-t"
                 theme="outlined-light"
                 widthClass="full-width"
                 [routerLink]="['/a/forgot-password']">
        Forgot password
      </a7-button>
    </a7-auth-form-tab>
  </mat-tab>

  <!-- selectedIndex 3: internal server error -->
  <mat-tab>
    <a7-auth-form-tab>
      <div class="center-inner">
        <div class="color-green-grey-1 h1">
          Oops! We Can’t Verify Your Identity
        </div>
      </div>
      <div class="body-2 color-green-grey-3 v2-margin-40px-t">
        The information you entered does not match our records. Please double-check and try again.
      </div>
      <div class="center-inner v2-margin-40px-t">
        <img src="/assets/v2-fail.svg"
             alt="back" />
      </div>
      <a7-button a7-auth-form-actions
                 class="v2-margin-40px-t"
                 theme="outlined-light"
                 widthClass="full-width"
                 [routerLink]="['/a/forgot-password']">
        Go back
      </a7-button>
    </a7-auth-form-tab>
  </mat-tab>

  <!-- selectedIndex 4: Reset success -->
  <mat-tab>
    <a7-auth-form-tab>
      <div class="center-inner">
        <div class="color-green-grey-1 h1 nowrap">
          Reset Successful
        </div>
      </div>
      <div class="body-2 color-green-grey-3 v2-margin-40px-t">
        Your password has been updated successfully. Please use your new password to login.
      </div>
      <div class="center-inner v2-margin-40px-t">
        <img src="/assets/v2-success.svg"
             alt="back" />
      </div>
      <a7-button a7-auth-form-actions
                 theme="filled-heavy"
                 widthClass="full-width"
                 class="v2-margin-40px-t"
                 (click)="navigateToSignIn()">
        Login
      </a7-button>
    </a7-auth-form-tab>
  </mat-tab>
</mat-tab-group>
